// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"c56c50c7e1cff7f26d56","683":"4e1d0333ecefe6e62c84","973":"1dd4613f81a247fc69b9"}[chunkId] + ".js";
};